import {
  Home,
  Briefcase,
  FileText,
  FileSignature,
  User,
  Heart,
  Bell,
  Settings,
  LogOut,
  Mail,
  MessageCircle,
  Accessibility,
  LifeBuoy,
  ArrowLeft,
  GraduationCap,
  Award,
  Languages,
  Search,
  Sparkles,
  Calendar,
  History,
  Files,
  Users,
  Clock,
  type LucideIcon,
} from 'lucide-react';

const MAP: Record<string, LucideIcon> = {
  Home,
  Briefcase,
  FileText,
  FileSignature,
  User,
  Heart,
  Bell,
  Settings,
  LogOut,
  Mail,
  MessageCircle,
  Accessibility,
  LifeBuoy,
  ArrowLeft,
  GraduationCap,
  Award,
  Languages,
  Search,
  Sparkles,
  Calendar,
  History,
  Files,
  Users,
  Clock,
};

export function resolveIcon(name: string): LucideIcon {
  return MAP[name] ?? Home;
}
